import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { roleHome } from './roleHome';

export default function RequireRole({ role, children }) {
  const { session } = useAuth();
  const loc = useLocation();

  const currentRole = String(session?.role || '').toLowerCase();

  if (!currentRole) return <Navigate to="/" replace state={{ from: loc }} />;

  if (role && currentRole !== String(role).toLowerCase()) {
    return <Navigate to={roleHome(currentRole)} replace />;
  }

  return children;
}
